"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResultColumnType;
(function (ResultColumnType) {
    ResultColumnType["COLUMN"] = "column";
    ResultColumnType["FUNC"] = "function";
    ResultColumnType["FORMULA"] = "formula";
})(ResultColumnType || (ResultColumnType = {}));
exports.default = ResultColumnType;
//# sourceMappingURL=ResultColumnType.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/abstract_query/interfaces/ResultColumnType.js
// module id = 161
// module chunks = 8